import React, { Component, Fragment } from 'react';

export default class Menu extends Component {
    render() {
        const { id } = this.props;
        return (
            <div className="dropdown">
                <a className="btn btn-sm btn-icon-only text-light" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i className="fas fa-ellipsis-v" />
                </a>
                <div className="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
                    <a className="dropdown-item" href="#">Exportar Comprovante</a>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/Bills/Menu.js